'use strict';
import has from 'lodash/has';
import isArray from 'lodash/isArray';
import isFunction from 'lodash/isFunction';
import isString from 'lodash/isString';

export function buildInjector(injections, list) {
  return [
    ...list,
    function (...args) {
      list.forEach((it, i) => injections[it] = args[i]);
    }
  ]
}

export function runInjector(injectable) {
  if (!isArray(injectable.$inject)) {
    throw new Error(`Attempted to inject ${injectable} but missing required $inject!`);
  }

  return [
    '$injector',
    function ($injector) {
      inject($injector, injectable);

      if (isFunction(injectable.postConstruct)) {
        const AppBootstrapper = $injector.get('AppBootstrapper');
        AppBootstrapper.loaded().then(() => injectable.postConstruct())
      }
    }
  ]
}

export function inject($injector, injectable) {
  if (!isArray(injectable.$inject)) {
    throw new Error(`Attempted to inject ${injectable} but missing required $inject!`);
  }

  injectable.dependencies = injectable.$inject.reduce((acc, name) => {
    acc[name] = $injector.get(name);
    return acc;
  }, {});
}

/**
 *
 * @param injector
 * @param {Object}  mocks
 */
export function mockInjector(injector, mocks) {
  if (isFunction(injector))
    return injector();
  if (!isArray(injector))
    throw new Error(`Invalid injector provided. Expected Function or Array and received ${typeof injector}: ${JSON.stringify(injector)}`);
  const len = injector.length;
  if (len < 1)
    throw new Error(`Invalid injector provided. Array length must be at least 1`);
  const fun = injector[len - 1];
  if (!isFunction(fun))
    throw new Error(`Invalid injector provided. Expected last item to be a Function and received ${typeof fun}`);
  const plannedArgs = injector.filter(it => isString(it));
  if (plannedArgs.length !== len - 1)
    throw new Error(`Invalid injector provided. Expected all items except the last to be strings. Received ${plannedArgs.length} of ${len - 1} valid items.`);

  const args = plannedArgs.map(key => has(mocks, key) ? mocks[key] : throwMissingKey(key));
  return fun(...args);
}

function throwMissingKey(key) {
  throw new Error(`Missing required mock "${key}"`);
}



// WEBPACK FOOTER //
// ./src/js/_libs/angular-utils/index.js